import m from "mithril";
import dayjs from 'dayjs';

export function DateRageComponent(): m.Component<{
    checkin : string,
    checkout : string,
    showHightLight? : boolean,
    checkinPlaceholder : string,                                
    checkoutPlaceholder : string,
    singularNightLabel : string,
    pluralNightLabel : string,
    onDateRangePickerClick: () => void;
}> {
    return {
        view(vnode) {
            let {checkin, checkout, showHightLight, checkinPlaceholder, checkoutPlaceholder, singularNightLabel, pluralNightLabel, onDateRangePickerClick} = vnode.attrs;
            let isoStartDate:string = checkin;
            let isoEndDate:string = checkout;
            let numberOfNight = ( isoStartDate != null && isoEndDate != null)? 
                dayjs(isoEndDate).diff(isoStartDate, 'day'): 0;

            return m("div.border", {
                class:showHightLight? "p-2 shadow-sm rounded clickable border-primary bg-white" : "p-2 shadow-sm rounded clickable bg-white",
                onclick: (event) => {
                    onDateRangePickerClick()
                }
            }, [
                m("i.bi bi-calendar4 text-primary"),
                ( isoStartDate != null && isoEndDate != null)?
                [
                    m("span", {class: "pl-2"}, dayjs(isoStartDate).format("MMM D") + " - " + dayjs(isoEndDate).format("MMM D")), 
                    m("small.text-muted", " (" + numberOfNight + " " + (numberOfNight > 1 ? pluralNightLabel: singularNightLabel) +  ")")
                ]: 
                m("span", {class: "pl-2 text-muted text-truncate"}, checkinPlaceholder + " - " + checkoutPlaceholder)
            ]
        );
        }
    }
}


export default DateRageComponent;

